import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-channel-telegram",
  "use": "foquz-icon-channel-telegram-usage",
  "viewBox": "0 0 19 16",
  "content": "<symbol viewBox=\"0 0 19 16\" fill=\"none\" id=\"foquz-icon-channel-telegram\"><path d=\"M9.984 12.09L7.919 14.1a.666.666 0 01-1.102-.285L5.44 9.285m6.852-3.174s-2.59 2.336-3.917 3.535a.843.843 0 00.066 1.305l5.378 3.973a.904.904 0 001.422-.54l2.64-12.447a.775.775 0 00-1.036-.884L1.33 7.037a.516.516 0 00.032.975L5.44 9.284\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-miterlimit=\"10\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol